// ✅ Images

// ─────────── Logos (no progressive loading needed) ───────────
import ifillip_logo_src from "../assets/images/ifillip-logo.png";
import Bcpl_logo_src    from "../assets/images/Home/BCPL_logo.png";

// ─────────── Full-quality images ───────────
import ifillip_school_students_full     from "../assets/images/Home/ifillip_school_students.png";
import ifillip_ai_dashboard_full    from "../assets/images/Home/ifillip_ai_dashboard.png";
import ifillip_process_automation_full     from "../assets/images/Home/ifillip_process_automation.png";
import ifillip_deep_insights_full     from "../assets/images/Home/ifillip_deep_insights.png";
import ifillip_stakeholder_dashboard_full     from "../assets/images/Home/ifillip_stakeholder_dashboard.png";
import ifillip_personalized_teaching_full      from "../assets/images/Home/ifillip_personalized_teaching.png";
import ifillip_mobile_app_full from "../assets/images/ifillip_mobile_app.png";
import ifillip_feature_image2_full from "../assets/images/Home/ifillip_feature_image2.png";
import ifillip_company_image2_full from "../assets/images/Home/ifillip_company_image2.png";

// ─────────── Auto-generated tiny blurred previews ───────────
import ifillip_school_students_tiny     from "../assets/images/Home/ifillip_school_students-tiny.png";
import ifillip_ai_dashboard_tiny    from "../assets/images/Home/ifillip_ai_dashboard-tiny.png";
import ifillip_process_automation_tiny     from "../assets/images/Home/ifillip_process_automation-tiny.png";
import ifillip_deep_insights_tiny     from "../assets/images/Home/ifillip_deep_insights-tiny.png";
import ifillip_stakeholder_dashboard_tiny     from "../assets/images/Home/ifillip_stakeholder_dashboard-tiny.png";
import ifillip_personalized_teaching_tiny      from "../assets/images/Home/ifillip_personalized_teaching-tiny.png";
import ifillip_mobile_app_tiny from "../assets/images/ifillip_mobile_app-tiny.png";
import ifillip_feature_image2_tiny from "../assets/images/Home/ifillip_feature_image2-tiny.png";
import ifillip_company_image2_tiny from "../assets/images/Home/ifillip_company_image2-tiny.png";

// ─────────── Helper ───────────
const pair = (src, lowSrc) => ({ src, lowSrc });

// ─────────── Logos (single src, no preview) ───────────
export const ifillip_logo = { src: ifillip_logo_src };
export const Bcpl_logo    = { src: Bcpl_logo_src };

// ─────────── Progressive images ({ src, lowSrc }) ───────────
export const ifillip_school_students     = pair(ifillip_school_students_full,     ifillip_school_students_tiny);
export const ifillip_ai_dashboard    = pair(ifillip_ai_dashboard_full,    ifillip_ai_dashboard_tiny);
export const ifillip_process_automation     = pair(ifillip_process_automation_full,     ifillip_process_automation_tiny);
export const ifillip_deep_insights     = pair(ifillip_deep_insights_full,     ifillip_deep_insights_tiny);
export const ifillip_stakeholder_dashboard     = pair(ifillip_stakeholder_dashboard_full,     ifillip_stakeholder_dashboard_tiny);
export const ifillip_personalized_teaching      = pair(ifillip_personalized_teaching_full,      ifillip_personalized_teaching_tiny);
export const ifillip_mobile_app = pair(ifillip_mobile_app_full, ifillip_mobile_app_tiny);
export const ifillip_feature_image2 = pair(ifillip_feature_image2_full, ifillip_feature_image2_tiny);
export const ifillip_company_image2 = pair(ifillip_company_image2_full, ifillip_company_image2_tiny);

// export const ifillip_company_image1 = pair(...); // commented out, same as before